var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDataFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Data Flows") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "4-8---Data-Map---Data-Flows",
    transform: "translate(-37.000000, -482.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Data-Flows",
    transform: "translate(37.000000, 482.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51485149,15 L0.48514851,15 C-0.335076363,15 -1,15.6800738 -1,16.5189873 L-1,21.4810127 C-1,22.3199262 -0.335076363,23 0.48514851,23 L7.51485149,23 C8.33507636,23 9,22.3199262 9,21.4810127 L9,16.5189873 C9,15.6800738 8.33507636,15 7.51485149,15 Z M0.48514851,16.5189873 L7.51485149,16.5189873 L7.51485149,21.4810127 L0.48514851,21.4810127 L0.48514851,16.5189873 Z",
    id: "Rectangle",
    transform: "translate(4.000000, 19.000000) rotate(90.000000) translate(-4.000000, -19.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5148515,15 L16.4851485,15 C15.6649236,15 15,15.6800738 15,16.5189873 L15,21.4810127 C15,22.3199262 15.6649236,23 16.4851485,23 L23.5148515,23 C24.3350764,23 25,22.3199262 25,21.4810127 L25,16.5189873 C25,15.6800738 24.3350764,15 23.5148515,15 Z M16.4851485,16.5189873 L23.5148515,16.5189873 L23.5148515,21.4810127 L16.4851485,21.4810127 L16.4851485,16.5189873 Z",
    id: "Rectangle",
    transform: "translate(20.000000, 19.000000) rotate(90.000000) translate(-20.000000, -19.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5148515,1 L16.4851485,1 C15.6649236,1 15,1.6800738 15,2.51898734 L15,7.48101266 C15,8.3199262 15.6649236,9 16.4851485,9 L23.5148515,9 C24.3350764,9 25,8.3199262 25,7.48101266 L25,2.51898734 C25,1.6800738 24.3350764,1 23.5148515,1 Z M16.4851485,2.51898734 L23.5148515,2.51898734 L23.5148515,7.48101266 L16.4851485,7.48101266 L16.4851485,2.51898734 Z",
    id: "Rectangle",
    transform: "translate(20.000000, 5.000000) rotate(90.000000) translate(-20.000000, -5.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51485149,1 L0.48514851,1 C-0.335076363,1 -1,1.6800738 -1,2.51898734 L-1,7.48101266 C-1,8.3199262 -0.335076363,9 0.48514851,9 L7.51485149,9 C8.33507636,9 9,8.3199262 9,7.48101266 L9,2.51898734 C9,1.6800738 8.33507636,1 7.51485149,1 Z M0.48514851,2.51898734 L7.51485149,2.51898734 L7.51485149,7.48101266 L0.48514851,7.48101266 L0.48514851,2.51898734 Z",
    id: "Rectangle",
    transform: "translate(4.000000, 5.000000) rotate(90.000000) translate(-4.000000, -5.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7,10 C20.7,11.9090302 19.1694112,12.8652853 16.465336,12.9231869 L16.1999999,12.9259877 L8,12.9259877 C5.76673769,12.9259877 4.77717509,13.3267672 4.70435853,13.9270245 L4.7,14 L3.3,14 C3.3,12.3290801 4.88533042,11.573765 7.72162583,11.5281895 L8,11.5259877 L16.1999999,11.5259877 C18.3130729,11.5259877 19.2286683,11.0372526 19.2959729,10.1129977 L19.3,10 L20.7,10 Z",
    id: "Path-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    points: "16 4.3 16 5.7 8 5.7 8 4.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    points: "16 18.8 16 20.2 8 20.2 8 18.8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDataFlow);
export default __webpack_public_path__ + "static/media/ic_data_flow.e5accb72aa8944338463e7e94487011a.svg";
export { ForwardRef as ReactComponent };